import {setFilter} from "../../../store/actions/creator/creatorExperienceManager";
import {optimizeLiveGraph, removeCliped, updateSettings} from '../../../store/actions/creator/analysis';
import {useDispatch, useSelector} from 'react-redux';
import UtilService from '../../../helper/service';
import {useHistory} from 'react-router';
import roles from '../../../helper/roles';
import {Breadcrumbs, Link, makeStyles, Typography} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  breadcrumb: {
    marginTop: 5,
    marginBottom: theme.spacing(-0.7),
    marginLeft: '80px!important',
    textTransform: 'uppercase',
    '@media only screen and (max-width: 786px)': {
      marginLeft: '10px!important',
    }
  },
  breadcrumbtxt: {
    fontSize: 11,
    color: '#606B76',
    cursor: 'pointer',
    fontFamily: 'roboto-regular'
  },
}));

function AnalyzeBreadcrumb() {

  const { currentSession, cliped } = useSelector((state: any) => state.analysis);
  const participants = useSelector((state: any) => state.experience.participants);
  const { projects } = useSelector((state: any) => state.creatorDashboard);

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

  const checkAndGoCreatorDashboard = () => {
    let url = '/creator/dashboard';
    const creator_dashboard = loginUserData.role_access.filter((val: any) => val.access_name === "creator_dashboard");
    if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
      url = "/creator/dashboard"
    }
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
      url = "/subscriber/creator/dashboard";
    }
    history.push(url);
  };

  const goCreatorDashboard = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    dispatch(removeCliped());
    localStorage.setItem("projectId", "-1");
    checkAndGoCreatorDashboard();
  };

  const getProjectId = () => {
    if (!localStorage.getItem("projectId")) {
      return -1
    } else {
      return localStorage.getItem("projectId");
    }
  };

  const goCreatorDashboardFolder = (e: any, projectId: any) => {
    e.preventDefault();
    localStorage.setItem("projectId", String(projectId));
    localStorage.setItem("fromTopBar", String(true));
    checkAndGoCreatorDashboard();
  };

  const getBreadCrumbProjectTitle = (pid: any) => {
    pid = Number(pid);
    if (pid === "-1") return '';
    if (projects.length === 0) {
      return '';
    } else {
      if (participants && participants.session && participants.session.project_folders && participants.session.project_folders.length > 0) {
        const result = participants.session.project_folders.filter((p: any) => Number(p) === pid);
        if (result && result.length > 0) {
          const projectName = projects.filter((project: any) => Number(project.projectId) === pid);
          if (projectName && projectName.length > 0) {
            return projectName[0].projectName
          } else {
            return ''
          }
        } else {
          return '';
        }
      } else {
        const projectName = projects.filter((project: any) => Number(project.projectId) === pid);
        if (projectName && projectName.length > 0) {
          return projectName[0].projectName
        } else {
          return ''
        }
      }
    }
  };

  const getBreadCrumbSessionTitle = (exp: any) => {
    return exp?.session['session_title']
  };

  const isClipAvailable = () => {
    return (location.pathname.includes('/analyze') || location.pathname.includes('/compare') || location.pathname.includes('/overview'));
  }

  const handleBreadItemClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    dispatch(updateSettings('addNoteX', -1));
    dispatch(updateSettings('addNoteY', -1));
    dispatch(removeCliped());
    dispatch(setFilter(true));
    if (isClipAvailable()) {
      localStorage.setItem('session_id', currentSession.session_id);
    }
    dispatch(optimizeLiveGraph())
  };

  const getExperienceManagerTabName = () => {
    if (location.pathname.includes('/overview')) {
      return "Report Card";
    }
    if (location.pathname.includes('/analyze')) {
      return "Second-by-Second";
    }
    if (location.pathname.includes('/participants')) {
      return "Setup";
    }
    if (location.pathname.includes('/compare')) {
      return "Comparison";
    }
  }

  const checkExperienceManagerPath = () => {
    if (location.pathname.includes('/creator/dashboard')) {
      return true;
    } else
      if (location.pathname.includes('/overview')) {
        return true;
      } else if (location.pathname.includes('/analyze')) {
        return true;
      } else if (location.pathname.includes('/participants')) {
        return true;
      } else return location.pathname.includes('/compare');
  };

  return (
    checkExperienceManagerPath() ? (
      <div className={classes.breadcrumb}>
        {getBreadCrumbProjectTitle(getProjectId()) ? (
          <Breadcrumbs separator={'>'} aria-label="breadcrumb">
            <Link color="inherit" onClick={goCreatorDashboard}>
              <Typography className={classes.breadcrumbtxt}>Home</Typography>
            </Link>
            <Link color="inherit" onClick={(e: any) => goCreatorDashboardFolder(e, getProjectId())}>
              <Typography className={classes.breadcrumbtxt}>{getBreadCrumbProjectTitle(getProjectId())}</Typography>
            </Link>
            {location.pathname.includes('/creator/experience-manager') && !cliped &&
              <Link color="inherit">
                <Typography className={classes.breadcrumbtxt}>{getExperienceManagerTabName()}</Typography>
              </Link>
            }
            {cliped && isClipAvailable() && <Link color="inherit" onClick={handleBreadItemClick}>
              <Typography className={classes.breadcrumbtxt}>{getBreadCrumbSessionTitle(participants)}</Typography>
            </Link>}
          </Breadcrumbs>
        ) : (
          <Breadcrumbs separator={'>'} aria-label="breadcrumb">
            {
              ( location.pathname.includes('/creator/dashboard') && Number(getProjectId()) === -1 ) ?
                <Link color="inherit" onClick={goCreatorDashboard} style={{display:"none"}}>
                  <Typography className={classes.breadcrumbtxt}>Home</Typography>
                </Link>  
              :
                <Link color="inherit" onClick={goCreatorDashboard}>
                  <Typography className={classes.breadcrumbtxt}>Home</Typography>
                </Link>  
            }
            {location.pathname.includes('/creator/experience-manager') && !cliped &&
              <Link color="inherit">
                <Typography className={classes.breadcrumbtxt}>{getExperienceManagerTabName()}</Typography>
              </Link>
            }
            {cliped && isClipAvailable() && <Link color="inherit" onClick={handleBreadItemClick}>
              <Typography className={classes.breadcrumbtxt}>{getBreadCrumbSessionTitle(participants)}</Typography>
            </Link>}
          </Breadcrumbs>
        )}
      </div>
    ) : <></>
  )
}

export default AnalyzeBreadcrumb;